<template>
  <div v-if="auctionSelected">
    <v-layout>
      <v-flex xs6>
        <v-btn outline color="primary" @click="$emit('changeOtherAuction')">
          {{ $t('Back') }}
        </v-btn>
      </v-flex>
      <v-flex xs6 class="text-xs-right">
        <v-btn v-if="checkIsActiveAll" dark color="primary" @click="auctionEnd(auctionSelected)">
          {{ $t('end_of_auction') }}
        </v-btn>
        <h2 v-else>{{ $t('this_auction_has_ended') }}</h2>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex xs12>
        <div class="mt-2 mb-3">
          <h3 style="color:#000">
            {{ $t('auction_name') }} :
            <span class="primary--text">{{ auctionSelected.auction_title }}</span>
          </h3>
          <h3 class="mt-1" style="color:#000">
            {{ $t('post') }} : <span class="primary--text">{{ postidlist }}</span>
          </h3>
        </div>
      </v-flex>
    </v-layout>
    <v-layout>
      <v-flex>
        <h2>
          {{ $t('products') }}
          <v-btn outline color="primary" v-if="checkIsActiveAll" @click="editAuctionProduct()">
            <i class="fas fa-plus mr-1"></i>
            {{ $t('edit_auction_product') }}
          </v-btn>
        </h2>
      </v-flex>
      <v-flex class="text-xs-right">
        <v-pagination :total-visible="5" v-model="pageNumber" :length="pagelength"></v-pagination>
      </v-flex>
    </v-layout>
    <v-layout class="my-1">
      <v-flex xs12 sm6>
        <v-btn :outline="filter !== 'all'" color="primary" @click="filterProduct('all')">
          {{ $t('all') }} ({{ auctionSelectedProductData.length }})
        </v-btn>
        <v-btn :outline="filter !== 'start'" color="primary" @click="filterProduct('start')">
          {{ $t('available_auction_item') }}
        </v-btn>
        <v-btn :outline="filter !== 'end'" color="primary" @click="filterProduct('end')">
          {{ $t('unavailable_auction_item') }}
        </v-btn>
      </v-flex>
      <v-flex xs12 sm6 class="text-xs-right">
        <v-btn outline color="primary" @click="expandOrCollapseAll(true)">
          <i class="fas fa-expand-arrows-alt mr-1"></i>
          {{ $t('Expand All') }}
        </v-btn>
        <v-btn outline color="primary" @click="expandOrCollapseAll(false)">
          <i class="fas fa-compress mr-1"></i>
          {{ $t('Collapse All') }}
        </v-btn>
      </v-flex>
    </v-layout>
    <div v-if="loading">
      <div class="spinner text-xs-center mb-5 mt-5">
        <img class="z-loop" src="/static/img/assets/loading/z-loop.png" alt="loading" />
      </div>
    </div>
    <div v-else-if="auctionProductData <= 0">
      <div class="text-xs-center mb-5 mt-5">
        <h2>{{ $t('auction_not_found') }}</h2>
      </div>
    </div>
    <div v-else class="intent-item z-border-red pa-0">
      <template v-for="(product, index) in auctionProductData">
        <vue-countdown
          :key="index"
          v-if="product.end_at"
          @end="onCountdownEnd(product)"
          :time="addNewDuringMonth(product.end_at)"
          v-slot="{ days, hours, minutes, seconds }"
        >
          <div :style="product.is_active ? '' : 'background: #d3d3d382'">
            <v-layout
              :style="
                days === 0
                  ? hours === 0
                    ? minutes === 0
                      ? seconds < 60
                        ? `background: #ffdbe9`
                        : ''
                      : ''
                    : ''
                  : ''
              "
              class="pt-3"
              wrap
            >
              <v-flex xs2>
                <v-img
                  v-if="product.product_image_url"
                  style="width: 90%; background-size: contain;"
                  :src="product.product_image_url"
                ></v-img>
              </v-flex>

              <v-flex xs10>
                <v-layout wrap>
                  <v-flex xs6>
                    <div class="my-2">
                      <p>{{ $t('products_name') }} :</p>
                      {{ product.product_title }}
                    </div>
                  </v-flex>
                  <v-flex xs6>
                    <div class="my-2">
                      <p>{{ $t('starting_price') }} :</p>
                      {{ product.start_price }}
                    </div>
                  </v-flex>
                  <v-flex xs6>
                    <div class="my-2">
                      <p>{{ $t('keyword') }} :</p>
                      {{ setQval(product.q_val) }}
                    </div>
                  </v-flex>
                  <v-flex xs6>
                    <div class="my-2">
                      <p>{{ $t('minimum_bid') }} :</p>
                      {{ product.minimum_bid }}
                    </div>
                  </v-flex>

                  <v-flex
                    xs12
                    v-if="
                      product.schedule_notify_max_bid_within_seconds && product.schedule_is_active
                    "
                  >
                    <p>
                      {{ $t('enable_the_latest_bid_updates') }}
                    </p>
                    {{
                      (
                        '0' +
                        Math.floor(
                          parseInt(product.schedule_notify_max_bid_within_seconds) / 60 / 60
                        )
                      ).slice(-2)
                    }}
                    :
                    {{
                      (
                        '0' +
                        JSON.stringify(
                          (parseInt(product.schedule_notify_max_bid_within_seconds) / 60) % 60
                        )
                      ).slice(-2)
                    }}</v-flex
                  >

                  <v-flex xs6>
                    <div class="my-2">
                      <template v-if="product.is_active">
                        <h2>
                          {{ $t('expired') }} : {{ $t('date') }}
                          {{ getFormatDate(product.end_at, 'DD/MM/YYYY') }} {{ $t('time') }}
                          {{ getFormatDate(product.end_at, 'HH:mm') }}
                        </h2>
                        <h2>
                          {{ $t('Remaining time') }} :
                          {{
                            days !== 0
                              ? `${days} ${$t('date')} ${hours} ${$t('hour')} ${minutes} ${$t(
                                  'minute'
                                )} ${seconds} ${$t('second')}`
                              : `${hours} ${$t('hour')} ${minutes} ${$t('minute')} ${seconds} ${$t(
                                  'second'
                                )}`
                          }}
                        </h2>
                      </template>
                      <h2 v-else>{{ $t('this_auction_has_ended') }}</h2>
                    </div>
                  </v-flex>
                  <v-flex xs6>
                    <div class="my-2">
                      <v-btn
                        :disabled="!product.is_active"
                        outline
                        color="primary"
                        @click="changeExtraTime(product)"
                      >
                        {{ $t('extend_minutes') }}
                      </v-btn>
                      <v-btn
                        :disabled="!product.is_active"
                        color="primary"
                        @click="closeAuctionById(product)"
                      >
                        {{ $t('close_auction_for_this_product') }}
                      </v-btn>
                    </div>
                  </v-flex>
                </v-layout>
              </v-flex>
              <v-flex xs12>
                <div class="text-xs-center">
                  <v-btn
                    dark
                    depressed
                    color="primary"
                    @click="$set(showAdvance, index, !showAdvance[index])"
                  >
                    {{ $t('auction_result_details') }}
                    <i class="ml-2 fas fa-angle-down" v-if="!showAdvance[index]"></i>
                    <i class="ml-2 fas fa-angle-up" v-else></i>
                  </v-btn>
                </div>
                <div class="mt-2" v-if="showAdvance[index]">
                  <dashboard-customer
                    v-model="auctionSelectedProductData[index]"
                    :auctionSelected="auctionSelected"
                    :showAdvance="showAdvance[index]"
                  ></dashboard-customer>
                </div>

                <v-divider class="mt-3"></v-divider>
              </v-flex>
            </v-layout>
          </div>
          <v-dialog v-model="isChangeExtraTime" persistent scrollable max-width="1000px">
            <v-card>
              <v-card-text style="height: 185px;">
                <v-layout wrap>
                  <v-flex xs12 class="pl-1">
                    <time-picker
                      class="mt-1"
                      v-model="extraTime"
                      full-width
                      hide-disabled-minutes
                      @input="setEndtime"
                      :placeholder="$t('time')"
                    ></time-picker>
                  </v-flex>
                </v-layout>
              </v-card-text>
              <v-divider></v-divider>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="grey" outline @click="isChangeExtraTime = false">{{
                  $t('cancel')
                }}</v-btn>
                <v-btn color="primary" depressed @click="editLiveProductAuction">{{
                  $t('Select')
                }}</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <v-dialog v-model="isEditDialog" persistent scrollable max-width="1000px">
            <v-card>
              <v-card-text>
                <template v-for="(product, index) in auctionProductDataEdit">
                  <product-form
                    v-if="product.action_type !== 'delete'"
                    @arrayProductRemove="arrayProductRemove(product.id)"
                    :key="`product_${timestamp}_${index}`"
                    v-model="auctionProductDataEdit[index]"
                    :index="index"
                    :errorTime.sync="errorTime"
                  >
                  </product-form>
                </template>
                <div style="margin-bottom: 10px;" @click="addProducts()">
                  <a href="javascript:void(0);">
                    <div class="add-conversation text-xs-center">
                      <i class="fa fa-plus middle"></i>
                      {{ $t('add_product') }}
                    </div>
                  </a>
                </div>
              </v-card-text>
              <v-divider></v-divider>
              <div
                class="text-xs-center mt-2"
                style="color: red; font-size: 0.9em;"
                v-if="errorTime"
              >
                {{ $t('please_specify_a_time') }}
              </div>
              <v-card-actions class="mb-2">
                <v-spacer></v-spacer>
                <v-btn
                  color="grey"
                  outline
                  @click="
                    isEditDialog = false
                    auctionProductDataEdit = []
                  "
                  >{{ $t('cancel') }}</v-btn
                >
                <v-btn color="primary" depressed @click="editAuction">{{ $t('Save') }}</v-btn>
                <v-spacer></v-spacer>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </vue-countdown>
      </template>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import VueCountdown from '@chenfengyuan/vue-countdown'
import TimePicker from '@/components/elements/TimePicker.vue'
import DashboardCustomer from './DashboardCustomer.vue'
import ProductForm from '@/components/view/liveAuction/ProductForm.vue'
import dayjs from 'dayjs'
export default {
  props: ['value'],
  components: {
    VueCountdown,
    TimePicker,
    DashboardCustomer,
    ProductForm
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot'
    }),
    pagelength() {
      const vm = this
      if (vm.auctionSelectedProductData) {
        return Math.ceil(vm.auctionSelectedProductData.length / 5)
      } else {
        return 1
      }
    },

    checkIsActiveAll() {
      const vm = this
      return vm.auctionSelectedProductData.some(item => item.is_active === true)
    },
    auctionProductData() {
      const vm = this
      let items = []
      if (vm.filter === 'start') {
        items = vm.auctionSelectedProductData.filter(item => item.is_active)
      } else if (vm.filter === 'end') {
        items = vm.auctionSelectedProductData.filter(item => !item.is_active)
      } else {
        items = vm.auctionSelectedProductData
      }
      return items.slice((vm.pageNumber - 1) * 5, vm.pageNumber * 5)
    },
    postidlist() {
      const vm = this
      if (
        vm.auctionSelected &&
        vm.auctionSelected.postidlist &&
        JSON.parse(vm.auctionSelected.postidlist)
      ) {
        return JSON.parse(vm.auctionSelected.postidlist).name
      }
    }
  },
  provide() {
    return { parentValidator: this.$validator }
  },
  data() {
    return {
      filter: 'start',
      openModalDate: false,
      timestamp: dayjs().format('x'),
      auctionSelected: this.value,
      auctionSelectedProductData: [],
      auctionProductDataEdit: [],
      productSelect: null,
      showAdvance: [],
      isChangeExtraTime: false,
      extraTime: null,
      extraDate: null,
      setExtraTime: null,
      pageNumber: 1,
      total_count: 0,
      loading: false,
      isEditDialog: false,
      errorTime: false
    }
  },
  mounted() {
    this.getProductsLiveAuction()
  },
  methods: {
    editAuctionProduct() {
      const vm = this
      vm.isEditDialog = true
      vm.auctionProductDataEdit = vm.auctionProductData
      vm.timestamp = dayjs().format('x')
    },
    async editAuction() {
      const vm = this
      const checkTime = vm.auctionProductDataEdit.map(item => {
        return new Date(item.end_at) > dayjs(new Date())
      })
      if (checkTime.includes(false)) {
        vm.errorTime = true
      } else {
        let data = {
          pageId: vm.selectedBot.pageid,
          auctionId: vm.auctionSelected.id,
          body: {
            product_data: vm.auctionProductDataEdit.map(el => {
              return {
                action_type: el.action_type || 'update',
                auction_product_id: el.id,
                product_title: el.product_title,
                product_image_url: el.product_image_url,
                q_type: el.q_type,
                q_val: `includes(${el.q_val})`,
                start_price: parseInt(el.start_price),
                minimum_bid: parseInt(el.minimum_bid),
                start_at: el.start_at,
                end_at: el.end_at,
                schedule_is_active: el.schedule_is_active,
                schedule_notify_max_bid_within_seconds: el.schedule_notify_max_bid_within_seconds
              }
            })
          }
        }
        try {
          const response = await api.updateProductAuction(data)
          if (response && response.success) {
            const result = response.result
            vm.$swal.fire({
              title: vm.$t('Successfully'),
              text: `${vm.$t('the_auction')} ${vm.auctionSelected.auction_title} ${vm.$t(
                'edit_the_auction_of'
              )}`,
              type: 'success'
            })
            vm.isEditDialog = false
            if (result && result.create_data && result.create_data.length > 0) {
              vm.auctionSelectedProductData = result.create_data.concat(
                vm.auctionSelectedProductData
              )
            }
            if (result && result.delete_data && result.delete_data.length > 0) {
              const itemsToRemove = result.delete_data.map(a => a.auction_product_id)
              vm.auctionSelectedProductData = vm.auctionSelectedProductData.filter(
                a => !itemsToRemove.includes(a.id)
              )
            }
          } else {
            vm.$swal.fire({
              title: vm.$t('Unsuccessful'),
              text: 'ข้อมูลไม่ถูกต้อง กรุณาตรวจสอบข้อมูลอีกครั้ง',
              type: 'error'
            })
          }
        } catch (error) {
          console.log(error)
          vm.$swal.fire({
            title: vm.$t('Unsuccessful'),
            text: 'ข้อมูลไม่ถูกต้อง กรุณาตรวจสอบข้อมูลอีกครั้ง',
            type: 'error'
          })
        }
      }
    },
    addProducts() {
      const vm = this
      vm.auctionProductDataEdit.push({
        action_type: 'create',
        product_title: null, // require
        product_image_url: null,
        q_type: 'text', // require
        q_val: 'includes()', // require
        start_price: null, // default 0
        minimum_bid: null, // default 0
        start_at: dayjs(), // yyyy-mm-dd HH:mm:ss
        end_at: vm.getFormatDate(dayjs(), 'YYYY-MM-DD'), // yyyy-mm-dd HH:mm:ss
        schedule_is_active: false,
        schedule_notify_max_bid_within_seconds: 0
      })
      vm.timestamp = dayjs().format('x')
    },
    arrayProductRemove(itemId) {
      const vm = this
      vm.auctionProductDataEdit = vm.auctionProductDataEdit.map(item => {
        if (item.id === itemId) {
          return { ...item, action_type: 'delete' }
        } else {
          return item
        }
      })
      vm.timestamp = dayjs().format('x')
    },
    setQval(q_val) {
      let pointer = null
      let keyword = null
      if (q_val.startsWith('includes(') && q_val.endsWith(')')) {
        pointer = q_val.search(/\(/g)
        keyword = q_val.substring(pointer + 1, q_val.length - 1)
        return keyword
      } else {
        return q_val
      }
    },
    async getProductsLiveAuction() {
      const vm = this
      vm.loading = true
      vm.data = null
      const data = {
        pageId: vm.selectedBot.pageid,
        auctionId: vm.auctionSelected.id,
        params: {
          //   with_product: true,
          //   filter_status: 'active'
          //   // limit: limit,
          //   // offset: offset
        }
      }
      let response = await api.getProductsLiveAuction(data)
      if (response.success) {
        vm.auctionSelectedProductData = response.result
        vm.total_count = response.total_count
      }
      vm.loading = false
    },
    setEndtime() {
      const vm = this
      vm.errorTime = false
      vm.setExtraTime = dayjs(vm.productSelect.end_at)
        .add(vm.extraTime ? vm.extraTime.HH || '00' : '00', 'hours')
        .add(vm.extraTime ? vm.extraTime.mm || '00' : '00', 'minutes')
        .format()
    },
    getFormatDate: function(date, format) {
      return dayjs(date).format(format)
    },
    filterProduct(type) {
      const vm = this
      vm.filter = type
      vm.pageNumber = 1
    },
    expandOrCollapseAll(type) {
      const vm = this
      if (vm.auctionProductData) {
        vm.auctionProductData.map((item, index) => {
          vm.$set(vm.showAdvance, index, type)
        })
      }
    },
    async closeAuctionById(product) {
      const vm = this
      let result = await vm.$swal.fire({
        title: vm.$t('do_you_want_to_end_the_auction_of', {
          name: product.product_title
        }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        vm.apiCloseAuctionById(product)
      }
    },

    async apiCloseAuctionById(product) {
      const vm = this
      let res = await api.closeAuctionById({
        pageId: vm.selectedBot.pageid,
        auctionId: vm.auctionSelected.id,
        productId: product.id
      })
      if (res.success) {
        product.is_active = false
        await vm.$swal.fire({
          title: vm.$t(`${vm.$t('the_auction')} ${product.product_title} ${vm.$t('has_ended')}`),
          type: 'success',
          confirmButtonText: vm.$t('Confirm'),
          reverseButtons: true
        })
      }
    },
    addNewDuringMonth(expiredDate) {
      const date1 = new Date()
      const date2 = new Date(expiredDate)
      const diffTime = Math.abs(date2 - date1)
      return diffTime
    },
    async auctionEnd(auctionSelected) {
      const vm = this
      let result = await vm.$swal.fire({
        title: vm.$t('do_you_want_to_end_the_auction', {
          name: auctionSelected.auction_title
        }),
        type: 'question',
        showCancelButton: true,
        confirmButtonText: vm.$t('Confirm'),
        cancelButtonText: vm.$t('cancel'),
        reverseButtons: true
      })
      if (result.value) {
        let res = await api.closeAllAuction({
          pageId: vm.selectedBot.pageid,
          auctionId: auctionSelected.id
        })
        if (res.success) {
          vm.auctionProductData.map(product => {
            product.is_active = false
          })
          await vm.$swal.fire({
            title: vm.$t(
              `${vm.$t('end_the_auction')} ${auctionSelected.auction_title} ${vm.$t('success')}`
            ),
            type: 'success',
            confirmButtonText: vm.$t('Confirm'),
            reverseButtons: true
          })
        }
      }
    },
    changeExtraTime(product) {
      const vm = this
      vm.productSelect = product
      vm.isChangeExtraTime = true
    },
    async editLiveProductAuction() {
      const vm = this
      if (vm.setExtraTime) {
        vm.productSelect.end_at = vm.setExtraTime
      }
      let res = await api.editLiveProductAuction({
        pageId: vm.selectedBot.pageid,
        auctionId: vm.auctionSelected.id,
        productId: vm.productSelect.id,
        body: vm.productSelect
      })
      if (res.success) {
        vm.isChangeExtraTime = false
        await vm.$swal.fire({
          title: `${vm.$t(`extend_minutes`)} ${res.result.product_title} ${vm.$t('success')}`,
          type: 'success',
          confirmButtonText: vm.$t('Confirm'),
          reverseButtons: true
        })
      }
    },
    onCountdownEnd(product) {
      const vm = this
      vm.apiCloseAuctionById(product)
    }
  }
}
</script>

<style lang="scss" scoped></style>


// WEBPACK FOOTER //
// src/components/view/liveAuction/DashboardAuctionDetail.vue